/**
 * noc-light.js
 * Directional light that follows the cursor.
 * Sets --mx / --my on :root (percentage of viewport).
 * CSS uses these in radial-gradient for a subtle glow effect.
 * Touch-aware: updates on touchmove too.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var rafId = 0;
  var cx = 50, cy = 30; /* default: upper-center */

  function setVars(x, y) {
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      root.style.setProperty('--mx', x.toFixed(2) + '%');
      root.style.setProperty('--my', y.toFixed(2) + '%');
    });
  }

  document.addEventListener('pointermove', function (e) {
    cx = (e.clientX / window.innerWidth)  * 100;
    cy = (e.clientY / window.innerHeight) * 100;
    setVars(cx, cy);
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var t = e.touches[0];
    if (!t) return;
    cx = (t.clientX / window.innerWidth)  * 100;
    cy = (t.clientY / window.innerHeight) * 100;
    setVars(cx, cy);
  }, { passive: true });

  /* Init defaults so CSS works before any movement */
  root.style.setProperty('--mx', cx + '%');
  root.style.setProperty('--my', cy + '%');
}());
